module.exports = __webpack_public_path__ + "static/media/javitott_meglevo_munkatars2.6d5dc671.jpg";